import React from 'react';

interface CursorBlinkProps {
  isActive?: boolean;
}

const CursorBlink: React.FC<CursorBlinkProps> = ({ isActive = true }) => {
  if (!isActive) return null;

  return (
    <span className="animate-blink text-current">|</span>
  );
};

export default CursorBlink;
